import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const rootProjectPath = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/v1.2/`;

export const workspaceMembersApi = createApi({
  reducerPath: 'workspaceMembersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: rootProjectPath,
    prepareHeaders: prepareFCHeader(),
  }),
  tagTypes: ['WorkspaceMembersList'],
  endpoints: builder => ({
    fetchWorkspaceMembers: builder.query({
      query: ({ organizationId, workspaceId, searchValue, limit = 100, offset = 0 }) => ({
        url: `organizations/${organizationId}/workspaces/${workspaceId}/members?limit=${limit}&offset=${offset}`,
        method: 'POST',
        body: {
          search_term: searchValue,
        },
      }),
      providesTags: ['WorkspaceMembersList'],
    }),
    addMemberToWorkspace: builder.mutation({
      query: ({ organizationId, workspaceId, userId }) => ({
        url: `organizations/${organizationId}/workspaces/${workspaceId}/add-member`,
        method: 'POST',
        body: {
          user_id: userId,
        },
      }),
      invalidatesTags: ['WorkspaceMembersList'],
    }),
    removeMemberFromWorkspace: builder.mutation({
      query: ({ organizationId, workspaceId, userId }) => ({
        url: `organizations/${organizationId}/workspaces/${workspaceId}/remove-member`,
        method: 'DELETE',
        body: {
          user_id: userId,
        },
      }),
      invalidatesTags: ['WorkspaceMembersList'],
    }),
  }),
});

export const {
  useFetchWorkspaceMembersQuery,
  useAddMemberToWorkspaceMutation,
  useRemoveMemberFromWorkspaceMutation,
} = workspaceMembersApi;
